import { Layout } from 'antd';
import { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import type { Dispatch } from 'redux';

import { HotelBuilder } from 'app/components/pages/Extranet/HotelBuilder/HotelBuilder';
import { ConfigContext } from 'app/context/ConfigContext/ConfigContext';
import { HotelContextProvider } from 'app/context/HotelContext/HotelContext';
import { UserContext } from 'app/context/UserContext/UserContext';
import { UsersnapProvider } from 'app/context/UsersnapContext/UsersnapContext';
import { useInitializeApp } from 'app/hooks/useInitializeApp';
import { initApp } from 'app/redux/actions/navigation';
import type { RootState } from 'app/redux/store';

type ExtAppProps = {
  appReady: boolean;
  init: () => void;
};

const ExtAppComponent = ({ appReady, init }: ExtAppProps) => {
  const { user, isAdmin } = useContext(UserContext);
  const config = useContext(ConfigContext);
  const hotelId = useInitializeApp('builder', user);

  useEffect(() => {
    init();
  }, [init]);

  if (!user || !appReady || !hotelId) {
    return null;
  }

  if (
    user &&
    !isAdmin &&
    (!user.hotelIds || !user.hotelIds.length) &&
    config?.appUrl
  ) {
    return <Redirect to={config.appUrl} />;
  }

  return (
    <UsersnapProvider>
      <HotelContextProvider urlHotelId={hotelId}>
        <Layout className="app">
          <Switch>
            <Route path="/ext/:hotelId" component={HotelBuilder} />
            <Redirect
              exact
              from="/ext"
              to={`/ext/${(user.hotelIds && user.hotelIds[0]) || 1}`}
            />
          </Switch>
        </Layout>
      </HotelContextProvider>
    </UsersnapProvider>
  );
};

const mapStateToProps = (state: RootState) => ({
  appReady: state.navigation.appReady ?? false,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  init: () => dispatch(initApp('builder')),
});

export const ExtApp = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ExtAppComponent)
);
